import { useCallback } from 'react'
import { usePreferencesDialog } from '../contexts/PreferencesDialogContext'
import type { PreferencesTarget } from '@/src/shared/preferencesNav'

/**
 * Öffnet die Einstellungen — mit `target` gleich auf einer Seite, ggf. im Ablauf (#158). Am Desktop ein
 * eigenes Fenster über den Hauptprozess, im Web der Dialog.
 */
export function useOpenPreferences() {
  const dialog = usePreferencesDialog()
  return useCallback((target?: PreferencesTarget) => {
    if (window.api?.invoke) void Promise.resolve(window.api.invoke('preferences:open-target', target)).catch(() => {})
    else dialog?.open(target)
  }, [dialog])
}
